import "./index-legal-page-layout.css";

export default function LegalPageLayout({
  eyebrow,
  title,
  description,
  toc = [],
  children,
}) {
  return (
    <div className="ep-page">
      <section className="ep-page-hero">
        <div className="ep-container">
          <div className="ep-page-hero-eyebrow">{eyebrow}</div>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </section>

      <main className="ep-section">
        <div className="ep-container ep-document-grid">
          <aside className="ep-toc">
            <div className="ep-toc-title">Nesta página</div>
            {toc.map((item) => (
              <a href={`#${item.id}`} key={item.id}>
                {item.label}
              </a>
            ))}
          </aside>

          <article className="ep-document">{children}</article>
        </div>
      </main>
    </div>
  );
}